import { StyleSheet } from 'react-native';

/**
 * The crest is drawn with NO chrome — no background, border or radius — matching the shipped
 * XpHeaderCluster, where the badge art is the whole visual (specs/rank-on-social-screens §7).
 * Callers position it; this only sizes it.
 */
export const getPlayerRankBadgeStyles = (size: number) =>
  StyleSheet.create({
    badge: {
      width: size,
      height: size,
    },
  });
